import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

const LogoutWarningModal = ({ isOpen, onStayLoggedIn, timeLeft }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
                <div className="flex items-center justify-center mb-4">
                    <FaExclamationTriangle className="text-yellow-500 text-4xl mr-3" />
                    <h2 className="text-2xl font-bold text-gray-800">Session Timeout Warning</h2>
                </div>
                <p className="text-gray-600 mb-4 text-center">
                    Your session will expire in {timeLeft} seconds due to inactivity.
                    Would you like to stay logged in?
                </p>
                <div className="flex justify-center space-x-4">
                    <button
                        onClick={onStayLoggedIn}
                        className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                    >
                        Stay Logged In
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LogoutWarningModal; 